function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.173,
    height: 15.626,
    viewBox: "0 0 24.173 15.626",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "view (1)",
    transform: "translate(0 -91.866)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 608",
    cx: 3.721,
    cy: 3.721,
    r: 3.721,
    transform: "translate(8.365 95.96)",
    style: {
      fill: "#e0e0df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16272",
    d: "M23.8 98.65c-2.861-3.457-7.191-6.784-11.715-6.784S3.23 95.2.371 98.65a1.618 1.618 0 0 0 0 2.062 24.226 24.226 0 0 0 4.238 4.01c5.068 3.689 9.876 3.7 14.955 0a24.226 24.226 0 0 0 4.238-4.01 1.618 1.618 0 0 0-.002-2.062zm-11.713-4.179a5.21 5.21 0 1 1-5.21 5.21 5.216 5.216 0 0 1 5.21-5.21z",
    style: {
      fill: "#e0e0df"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.bd417a2935730ce654a1ae72a29ee3e4.svg";
export { ForwardRef as ReactComponent };